import { Injectable } from '@angular/core';
import { FilterTypeModel } from '../../../Common/Filter/models/abstract-filter-type.model';
import { AuditableFilterService } from '../../../Common/Filter/services/auditable-filter.service';
import { UsersService } from '../../../Core/Users/services/users.service';
import { AuditableModel } from '../../../Common/Misc/models/auditable.model';
import { mergeMapTo, take, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class LeftHandPanelDefaultFilterService extends AuditableFilterService{

    constructor(protected usersService: UsersService) {
        super(usersService);
    }

    addFilters(filters: FilterTypeModel[]): Observable<FilterTypeModel[]> {
        // We set our new (non-auditable) filters, then wait for the call to
        // getAuditableFilterOptions to complete to ensure we have the auditable
        // options we need
        this.setFilters([...this.filters, ...filters]);
        return this.auditableFilterOptionsComplete$.pipe(
            take(1),
            tap(() => {
                this.applyFilters();
            }),
            mergeMapTo(this.getFlatFilters()),
        );
    }

    getAuditableFilterOptions(items: AuditableModel[]) {
        super.getAuditableFilterOptions(items);
    }

    emitFilters(filters: FilterTypeModel[]) {
        this.flatFilters$.next(filters);
    }
}
